var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSecuritySettings = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0781 16.5778V12.3099C23.0781 9.00048 20.1344 6.32 16.5 6.32C12.8656 6.32 9.92191 9.00482 9.92191 12.3142V16.5822H23.0781V16.5778ZM4.83949 16.6255L4.83473 16.4911V11.8024C4.83473 9.20434 5.96839 6.71036 7.98802 4.87133C10.0077 3.03229 12.7418 2 15.5997 2H17.405C23.3496 2 28.1653 6.3894 28.1653 11.7981V16.6255C30.9375 16.9769 33 19.1369 33 21.6872V32.8906C33 35.7142 30.4898 38 27.3889 38H5.61114C2.51025 38 0 35.7142 0 32.8906V21.6916C0 19.1412 2.0625 16.9812 4.83949 16.6255ZM15.2044 28.1629V31.5027C15.2044 32.1533 15.7855 32.6824 16.5 32.6824C17.2145 32.6824 17.7956 32.1533 17.7956 31.5027V28.1629C19.3913 27.5947 20.3202 26.0723 20.001 24.5412C19.6819 23.0058 18.2148 21.8954 16.5 21.8954C14.7852 21.8954 13.3134 23.0058 12.999 24.5412C12.6798 26.0723 13.6087 27.5947 15.2044 28.1629Z",
    fill: "url(#paint0_linear_4250_69571)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.499 31.0625L37.6342 29.6482C37.6539 29.4518 37.6735 29.2357 37.6735 29C37.6735 28.7643 37.6539 28.5482 37.6342 28.3518L39.499 26.9375C40.0093 26.5446 40.1467 25.8571 39.813 25.2679L37.7324 21.7518C37.4968 21.3393 37.0454 21.0839 36.5743 21.0839C36.4172 21.0839 36.2798 21.1036 36.1228 21.1625L33.9047 22.0268C33.5318 21.7714 33.1392 21.5554 32.7466 21.3786L32.4129 19.1196C32.3148 18.4714 31.7652 18 31.0978 18H26.8972C26.2298 18 25.6802 18.4714 25.582 19.1L25.268 21.3786C24.8754 21.5554 24.5024 21.7714 24.1099 22.0268L21.8918 21.1625C21.7347 21.1036 21.5777 21.0839 21.4207 21.0839C20.9496 21.0839 20.4981 21.3196 20.2822 21.7321L18.1819 25.2679C17.8482 25.8179 17.9856 26.5446 18.496 26.9375L20.3607 28.3518C20.3411 28.5875 20.3215 28.8036 20.3215 29C20.3215 29.1964 20.3215 29.4125 20.3607 29.6482L18.496 31.0625C17.9856 31.4554 17.8482 32.1429 18.1819 32.7321L20.2626 36.2482C20.4981 36.6607 20.9496 36.9161 21.4207 36.9161C21.5777 36.9161 21.7151 36.8964 21.8721 36.8375L24.0902 35.9732C24.4632 36.2286 24.8558 36.4446 25.2483 36.6214L25.582 38.8804C25.6605 39.5089 26.2298 40 26.8972 40H31.0978C31.7652 40 32.3148 39.5286 32.4129 38.9L32.7466 36.6214C33.1392 36.4446 33.5121 36.2286 33.9047 35.9732L36.1228 36.8375C36.2798 36.8964 36.4369 36.9161 36.5939 36.9161C37.065 36.9161 37.5165 36.6804 37.7324 36.2679L39.8327 32.7125C40.1467 32.1429 40.0093 31.4554 39.499 31.0625ZM33.7084 29C33.7084 31.5929 31.5885 33.7143 28.9975 33.7143C26.4064 33.7143 24.2865 31.5929 24.2865 29C24.2865 26.4071 26.4064 24.2857 28.9975 24.2857C31.5885 24.2857 33.7084 26.4071 33.7084 29Z",
    fill: "url(#paint1_linear_4250_69571)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4250_69571",
    x1: 16.5,
    y1: 2,
    x2: 16.5,
    y2: 38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7F741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9ECA25"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4250_69571",
    x1: 29,
    y1: 18,
    x2: 29,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#189EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3863D2"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSecuritySettings);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/security-settings.9e0b934989ca8606960a31521e855e13.svg";